<template>
  <BaseNew
    @new-confirm-action="createEntry"
    @new-cancel-action="resetForm"
    @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseNew"
    width="80%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
    :inlineAddButton="inlineAddButton"
  >
    <template slot="newForm">
      <Form
        ref="form"
        :entry="entry"
        :extraData="extraData"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      entry: new Object,
      formErrors: [],
      extraData: null,
    };
  },
  props: {
    inlineAddButton: {
      type: Boolean,
      default: false
    },
    isCustomer: {
      type: Boolean,
      default: false
    },
    isCollaborator: {
      type: Boolean,
      default: false
    },
    isSupplier: {
      type: Boolean,
      default: false
    },
    isCarrier: {
      type: Boolean,
      default: false
    },
    isEmployee: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseNew: BaseNew
  },
  methods: {
    loadServerEntry: function() {
      this.loading=false;
      // this.error = null;
      // this.loading = true;
      // this.$apollo
      //   .query({
      //     query: LOAD_NEW_PERSON_QUERY,
      //     fetchPolicy: "no-cache"
      //   })
      //   .then(response => {
      //     this.entry = response.data.accountContext.person;
      //     if (this.isCustomer) {
      //       this.entry.isCustomer = true;
      //     } 
      //     if (this.isCollaborator) {
      //       this.entry.isCollaborator = true;
      //     }
      //     if (this.isSupplier) {
      //       this.entry.isSupplier = true;
      //     }
      //     if (this.isCarrier) {
      //       this.entry.isCarrier = true;
      //     }
      //     if (this.isEmployee) {
      //       this.entry.isEmployee = true;
      //     }
      //     // console.log(this.entry);
      //     this.extraData = response.data;
      //   })
      //   .catch(response => console.log(response))
      //   .finally(() => (this.loading = false));

    },
    createEntry: function(){
       if (this.$refs.form.isFormValid()){
        this.$refs.baseNew.closeDialog();
        this.$emit("entry-created", this.entry);
        this.resetForm();
        return true;
      } else {
        return false;
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

</script>

<style scoped></style>
